export default function Hero() {
  const scrollToSolutions = () => {
    const solutionsSection = document.getElementById('solutions');
    if (solutionsSection) {
      solutionsSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-gradient-to-br from-slate-50 via-white to-slate-100">
      {/* Subtle grid pattern overlay */}
      <div className="absolute inset-0 opacity-[0.03]" style={{
        backgroundImage: `linear-gradient(to right, #000 1px, transparent 1px), linear-gradient(to bottom, #000 1px, transparent 1px)`,
        backgroundSize: '60px 60px'
      }}></div>

      {/* Elegant accent elements */}
      <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-gradient-to-bl from-emerald-100/40 via-transparent to-transparent rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 left-0 w-[500px] h-[500px] bg-gradient-to-tr from-slate-200/30 via-transparent to-transparent rounded-full blur-3xl"></div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-20">
        <div className="flex items-center gap-20">
          {/* Left: Content */}
          <div className="w-1/2">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-emerald-50 border border-emerald-200 rounded-full mb-8">
              <div className="w-2 h-2 bg-emerald-500 rounded-full animate-pulse"></div>
              <span className="text-sm font-medium text-emerald-700 tracking-wide">ONSQUARE INC.</span>
            </div>
            
            <h1 className="text-7xl font-bold text-slate-900 leading-[1.1] mb-8">
              Empowering<br />
              <span className="bg-gradient-to-r from-emerald-600 to-teal-600 bg-clip-text text-transparent">Global Growth</span>
            </h1>
            
            <p className="text-xl text-slate-600 mb-12 leading-relaxed max-w-xl">
              Transform your business with AI-powered solutions designed for companies expanding across borders and breaking into new markets.
            </p>
            
            <div className="flex items-center gap-4">
              <button 
                onClick={scrollToSolutions}
                className="group inline-flex items-center gap-3 bg-slate-900 text-white px-8 py-4 rounded-lg text-base font-semibold hover:bg-slate-800 transition-all duration-300 shadow-lg hover:shadow-xl hover:-translate-y-0.5 cursor-pointer whitespace-nowrap"
              >
                Explore Solutions
                <i className="ri-arrow-right-line text-xl transition-transform group-hover:translate-x-1"></i>
              </button>
              
              <button className="inline-flex items-center gap-2 text-slate-700 px-6 py-4 rounded-lg text-base font-semibold hover:bg-slate-100 transition-all duration-300 cursor-pointer whitespace-nowrap">
                <i className="ri-play-circle-line text-2xl"></i>
                Watch Demo
              </button>
            </div>

            {/* Trust indicators */}
            <div className="mt-16 pt-8 border-t border-slate-200">
              <div className="flex items-center gap-12">
                <div>
                  <div className="text-3xl font-bold text-slate-900">500+</div>
                  <div className="text-sm text-slate-600 mt-1">Global Clients</div>
                </div>
                <div>
                  <div className="text-3xl font-bold text-slate-900">50+</div>
                  <div className="text-sm text-slate-600 mt-1">Countries</div>
                </div>
                <div>
                  <div className="text-3xl font-bold text-slate-900">98%</div>
                  <div className="text-sm text-slate-600 mt-1">Success Rate</div>
                </div>
              </div>
            </div>
          </div>

          {/* Right: Visual */}
          <div className="w-1/2 relative">
            <div className="relative">
              {/* Main image */}
              <div className="relative rounded-2xl overflow-hidden shadow-2xl">
                <img 
                  src="https://public.readdy.ai/ai/img_res/3a3a2b5a1b1900e68e1738356c075039.jpg"
                  alt="Global Business Solutions"
                  className="w-full h-auto object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-slate-900/20 to-transparent"></div>
              </div>

              {/* Floating stat cards */}
              <div className="absolute -left-8 top-1/4 bg-white rounded-xl shadow-xl p-5 border border-slate-100 animate-float">
                <div className="flex items-center gap-3">
                  <div className="w-12 h-12 bg-emerald-100 rounded-lg flex items-center justify-center">
                    <i className="ri-global-line text-2xl text-emerald-600"></i>
                  </div>
                  <div>
                    <div className="text-2xl font-bold text-slate-900">145%</div>
                    <div className="text-xs text-slate-600">Market Growth</div>
                  </div>
                </div>
              </div>

              <div className="absolute -right-6 bottom-1/4 bg-white rounded-xl shadow-xl p-5 border border-slate-100 animate-float-delayed">
                <div className="flex items-center gap-3">
                  <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center">
                    <i className="ri-line-chart-line text-2xl text-teal-600"></i>
                  </div>
                  <div>
                    <div className="text-2xl font-bold text-slate-900">$2.4M</div>
                    <div className="text-xs text-slate-600">Avg. Revenue</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
